import React, { useState, useEffect } from 'react';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import axios from 'axios';
import { Modal, Button, Table } from 'react-bootstrap';
import { FaEdit, FaTrashAlt, FaArrowLeft, FaPlus, FaLink } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; 

const SessionTopic = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sessionTopic, setSessionTopic] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sessions, setSessions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [editSessionId, setEditSessionId] = useState(null);

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return date.toLocaleString('en-US', options).replace(',', '').replace(/\//g, '-');
    };

    // Fetch sessions
    const fetchSessions = async () => {
        try {
            const response = await axios.get('https://rvapi.emedha.in/pages/api/api/get-sessions');
            if (response.status === 200) {
                setSessions(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching sessions:', error);
            alert('Failed to fetch sessions');
        }
    };

    useEffect(() => {
        fetchSessions();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (editSessionId) {
                const response = await axios.put(`https://rvapi.emedha.in/pages/api/update-session/${editSessionId}`, {
                    sessionTopic,
                    startDate,
                    endDate
                });
                if (response.status === 200) {
                    const updatedSessions = sessions.map((session) =>
                        session.id === editSessionId
                            ? { ...session, sessiontopic: sessionTopic, start_dt: startDate, end_dt: endDate }
                            : session
                    );
                    setSessions(updatedSessions);
                    setIsModalOpen(false);
                    setEditSessionId(null);
                    setSessionTopic('');
                    setStartDate('');
                    setEndDate('');
                    alert('Session updated successfully!');
                }
            } else {
                // POST request for adding a session
                const response = await axios.post('https://rvapi.emedha.in/pages/api/api/add-session', {
                    sessionTopic,
                    startDate,
                    endDate
                });
                if (response.status === 200) {
                    setSessions([...sessions, { sessionTopic, startDate, endDate }]);
                    setSessionTopic('');
                    setStartDate('');
                    setEndDate('');
                    setIsModalOpen(false);
                    fetchSessions();
                    alert('Session added successfully!');
                }
            }
        } catch (error) {
            console.error('Error processing session:', error);
            alert('Failed to process session');
        }
    };

    const handleEdit = (session) => {
        setEditSessionId(session.id);
        setSessionTopic(session.sessiontopic);
        setStartDate(session.start_dt);
        setEndDate(session.end_dt);
        setIsModalOpen(true);
    };

    const navigate = useNavigate();

    const handleGenerateUrl = (session) => { 
        navigate(`/session/${session.id}/sessionForm`);
    };


    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`https://rvapi.emedha.in/pages/api/delete-session/${id}`);
            if (response.status === 200) {
                fetchSessions();
                alert('Session deleted successfully!');
            }
        } catch (error) {
            console.error('Error deleting session:', error);
            alert('Failed to delete session');
        }
    };

    const indexOfLastSession = currentPage * itemsPerPage;
    const indexOfFirstSession = indexOfLastSession - itemsPerPage;
    const currentSessions = sessions.slice(indexOfFirstSession, indexOfLastSession);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);



    return (
        <div className="mt-1" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '200px', width: '100%' }} />

            <div className="container d-flex justify-content-between mt-3">
                <Button className="btn btn-dark" onClick={() => window.history.back()}><FaArrowLeft /> Back</Button> {/* Added icon */}
                <Button onClick={() => setIsModalOpen(true)} className="btn btn-success"><FaPlus /> Add Session</Button> {/* Added icon */}
            </div>

            <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{editSessionId ? 'Edit Session' : 'Add Session'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Session Topic:</label>
                            <textarea type="text" value={sessionTopic} onChange={(e) => setSessionTopic(e.target.value)} className="form-control" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Start Date & Time:</label>
                            <input type="datetime-local" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="form-control" />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">End Date & Time:</label>
                            <input type="datetime-local" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="form-control" />
                        </div>
                        <Button type="submit" className="btn btn-success">{editSessionId ? 'Update' : 'Submit'}</Button>
                        <Button variant="danger" onClick={() => setIsModalOpen(false)} className="ms-2">Close</Button>
                    </form>
                </Modal.Body>
            </Modal>

            <div className="container mt-4">
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Session Topic</th>
                            <th>Start Date & Time</th>
                            <th>End Date & Time</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentSessions.map((session, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{session.sessiontopic}</td>
                                <td>{formatDate(session.start_dt)}</td>
                                <td>{formatDate(session.end_dt)}</td>
                                <td>
                                    <Button onClick={() => handleEdit(session)} className="btn btn-warning btn-sm me-2"><FaEdit /> Edit</Button> {/* Added icon */}
                                    <Button onClick={() => handleDelete(session.id)} className="btn btn-danger btn-sm me-2"><FaTrashAlt /> Delete</Button> {/* Added icon */}
                                    <Button onClick={() => handleGenerateUrl(session)} className="btn btn-info btn-sm"><FaLink /> Get URL</Button> {/* Added icon */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="btn btn-primary btn-sm">Previous</button>
                    <span style={{ margin: '0 10px' }}>Page {currentPage}</span>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage * itemsPerPage >= sessions.length} className="btn btn-primary btn-sm">Next</button>
                </div>
            </div>

            <footer className="bg-light py-3 mt-auto text-center">
                <div>
                    <p className="mb-0" style={{ fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px' }}>EMedha Technologies</a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" className="img-fluid" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default SessionTopic;
